<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  async mounted() {
    if (this.$store.state.islogin) {
      // CSRFトークン取得・設定
      await this.$axios.get("/api/v1/getcsrftoken").then(
        (res) =>
          (this.$axios.defaults.headers.common["X-CSRF-TOKEN"] =
            res.data.csrfToken),
        (err) => 
          this.$store.dispatch("auth", { loginUser: [], islogin: false })
      );
    }
  }
};
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
